import qs from 'querystring';
import axios from 'axios';
import logger from './logger';
const LOGGER_CONTEXT = 'REQUEST';

/**
 * Управляется через глобальную переменную LOGGER_LEVEL
 * todo - сделать "request" настраиваемым
 */
var LogLevel = /*#__PURE__*/function (LogLevel) {
  LogLevel["NoLogs"] = "no-logs";
  LogLevel["WithErrors"] = "with-errors";
  LogLevel["WithRequest"] = "with-request";
  LogLevel["All"] = "all";
  return LogLevel;
}(LogLevel || {});
const logLevel = process.env.LOGGER_LEVEL || LogLevel.WithErrors;
function requestLogger(request) {
  const {
    baseURL,
    url,
    params,
    method,
    data
  } = request;
  // @ts-ignore
  request.metadata = request.metadata || {};

  // @ts-ignore
  request.metadata.startTime = Date.now();
  if ([LogLevel.All, LogLevel.WithRequest].includes(logLevel)) {
    logger.info({
      context: LOGGER_CONTEXT,
      message: method?.toUpperCase() || '',
      request_url: url ? new URL(url, baseURL).toString() : '',
      meta: {
        params: JSON.stringify(params),
        data: JSON.stringify(data)
      }
    });
  }
  return request;
}
function responseLogger(response) {
  // @ts-ignore
  const startTime = response.config.metadata?.startTime || 0;
  if ([LogLevel.All].includes(logLevel)) {
    logger.info({
      context: LOGGER_CONTEXT,
      message: response.config.method?.toUpperCase() || '',
      request_url: response.config.url,
      http_status: response.status,
      ...(startTime ? {
        response_time: Date.now() - startTime
      } : {}),
      meta: {
        data: JSON.stringify(response.data)
      }
    });
  }
  return response;
}

/**
 * Make axios instance with default options
 * @example
 * ```javascript
 * const data await client.get('http://www.sravni.ru')
 * ```
 */
const request = axios.create({
  timeout: 5000,
  responseType: 'json',
  // eslint-disable-next-line @typescript-eslint/naming-convention
  headers: {
    'X-Requested-With': 'XMLHttpRequest'
  },
  paramsSerializer: {
    serialize: params => qs.stringify(params)
  }
});

// Add a request interceptor
request.interceptors.request.use(requestLogger, error => Promise.reject(error));

// Add a response interceptor
request.interceptors.response.use(responseLogger, error => {
  let status = 500;
  if (error.response) {
    status = error.response.status;
  }
  if ([LogLevel.All, LogLevel.WithRequest, LogLevel.WithErrors].includes(logLevel)) {
    logger.error({
      context: LOGGER_CONTEXT,
      message: 'Request ended with an error',
      request_url: error.config.url,
      http_status: status,
      exception: {
        message: error.message
      }
    });
  }
  return Promise.reject(error);
});
export default request;
export { requestLogger, responseLogger };
//# sourceMappingURL=request.js.map